import React, { useState } from "react";
import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import "./login.css";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import Wminput from "../ui-components/wm-form-components/input/Wm.input";
import logo from "../assets/images/logo2.svg";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import ReCAPTCHA from "react-google-recaptcha";
import {useHistory} from 'react-router-dom'

function Forgotpass() {
  const history = useHistory();
  function Alert(props) {return <MuiAlert elevation={6} variant="filled" {...props} />;}
  const [captaToken, setCaptaToken] = useState("");
  const [errorMes, setErrorMes] = useState({ emailError: '', captaError: '' });

  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isMailSentMessage, setIsMailSentMessage] = useState(false);
  function onChange(value) {
    setCaptaToken(value)
    setErrorMes((errorMes) => {
      errorMes.captaError = '';
      return {
        ...errorMes
      }
    })
  }
  const sendMailForForgotPassword = (e) => {
    if (validation()) {
      setIsLoading(true);
      e.preventDefault();
      var fd = new FormData();
      fd.append("email", email);
      axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Authentication/forgotPassword`, data: fd, })
        .then(() => {
          setIsLoading(false);
          setIsMailSentMessage(true);
        })
        .catch((err) => {
          setIsLoading(false);
          alert(err.response.data.message);
        });
    }
  };
  const validation = () => {
    let isSafe = true;
    if (email === '' || email === null || email === undefined) {
      isSafe = false;
      setErrorMes((errorMes) => {
        errorMes.emailError = 'Email is required';
        return {
          ...errorMes
        }
      })
    }
    if (!captaToken) {
      isSafe = false;
      setErrorMes((errorMes) => {
        errorMes.captaError = 'Please complete the reCaptcha';
        return {
          ...errorMes
        }
      })
    }
    return isSafe;
  }
  return (
    <>
      <div className="loginBg forgotBG_img py-5">
        <div className="login">
          <div className="flex justify-center mb-4">
            <img src={logo} alt="logo" className="w-48" />
          </div>
          <div className="login_container">
            <div className="wm-form-group flex flex-col mb-4">
              <label htmlFor="First name" className="text-sm">Email</label>
              <Wminput autocomplete='off' type="email" name="email_phone" onChange={(e) => {
                setEmail(e.target.value);
                setErrorMes((errorMes) => {
                  errorMes.emailError = '';
                  return {
                    ...errorMes
                  }
                })
              }} />
            </div>
            {errorMes.emailError && <span className="block text-center text-sm text-red-500">{errorMes.emailError}</span>}
            <div className="text-center w-full flex items-center justify-center mb-2">
              <ReCAPTCHA sitekey="6LerMHIcAAAAAOUy6oJG2xt0SDTuSVoNbPX4K4w3" onChange={onChange} />
            </div>
            {errorMes.captaError && <span className="block text-center text-sm text-red-500">{errorMes.captaError}</span>}
            <div className="wm-form-group flex mb-2">
              <Wmbutton className="h-10 login-btn" type="button" color="primary" label={`${isLoading ? "Loading..." : "Send Email"}`} onClick={(e) => sendMailForForgotPassword(e)} disable={isLoading} />
            </div>
            <div className="already_in_out">
              <p className="mr-2 fs-13">Remember Password?</p>
              <a href="/login" className="fs-13 underline">
                Login in
              </a>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMailSentMessage}
        autoHideDuration={6000}
        onClose={() => {setIsMailSentMessage(false);history.push('/login')}}
        className="toastSuccess"
      >
        <Alert onClose={() => {setIsMailSentMessage(false);history.push('/login')}}>
          Password Reset Link Has Been Sent To You Mail
        </Alert>
      </Snackbar>
    </>
  );
}

export default Forgotpass;
